import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Stack, IconButton, InputAdornment, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Iconify from '../../../components/iconify';

export default function LoginForm() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleClickShowPassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleLogin = async () => {
    setLoading(true);
    const response = await fetch(`https://asetran.cl/api/enex/acceso.php?email=${email}&password=${password}`);
    const data = await response.json();
    if (data === null){
      alert("Usuario y/o Contraseña no válidos.")
      setLoading(false);
    }

    if (data.length > 0) {
      const { Login, Mandante, Tipo, Transportista } = data[0];
      localStorage.setItem('Login', Login);
      localStorage.setItem('Mandante', Mandante);
      localStorage.setItem('Tipo', Tipo);
      localStorage.setItem('Transportista', Transportista);
      navigate('/dashboard/app', { replace: true });
    }
    
  };

  return (
    <>
      <Stack spacing={3}>
        <TextField
          name="email"
          label="E-mail"
          value={email}
          onChange={handleEmailChange}
        />

        <TextField
          name="password"
          label="Contraseña"
          type={showPassword ? 'text' : 'password'}
          value={password}
          onChange={handlePasswordChange}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleClickShowPassword} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      <LoadingButton
        fullWidth
        size="large"
        type="submit"
        variant="contained"
        loading={loading}
        onClick={handleLogin}
        style={{marginTop: '3%'}}
      >
        Ingresar
      </LoadingButton>
    </>
  );
}
